import { Injectable, signal } from '@angular/core';

/**
 * Holds the current native push (FCM/APNs) registration token in memory so it
 * can be read synchronously — e.g. by AuthService.login() to send it as
 * device_id — without waiting on a fresh PushNotifications 'registration'
 * event at the moment of login.
 */
@Injectable({ providedIn: 'root' })
export class PushTokenService {
  private readonly tokenSignal = signal<string | null>(null);
  readonly token = this.tokenSignal.asReadonly();

  setToken(token: string): void {
    this.tokenSignal.set(token);
  }
}
